import React from 'react';
import { Image, Table, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ThreeDScene from './ThreeDScene';
// import IconButton from 'components/common/IconButton';
import windTurbine from 'assets/img/landing-page/wind_turbine.png';
import TeamMembers from '../splash/TeamMembers';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="landing-page">
        <ThreeDScene />
        <header>
          <div className="content-fit">
            <div className="logo">Land Futures</div>
            <nav>
              <ul>
                <li>
                  <Button
                    className="outline-primary"
                    onClick={() => navigate('/home')}
                    style={{ padding: '0.5rem 1rem' }}
                  >
                    Start
                  </Button>
                </li>
              </ul>
            </nav>
          </div>
        </header>
        <div className="section" id="banner">
          <div className="content-fit">
            <div className="title">Land Futures</div>
          </div>
          <Image
            src={windTurbine}
            className="decorate"
            alt=""
            style={{ width: '30vw', bottom: 0, left: 0 }}
          />
        </div>
        <div className="section" id="intro">
          <div className="content-fit">
            <div className="number">01</div>
            <div className="des">
              <div className="title">
                Empowering Sustainable Land Management for Decarbonisation
              </div>
              <p>
                The Carbon Stock Exchange platform aims to revolutionize
                sustainable land management by incentivizing landowners to
                enhance carbon stocks through reforestation and carbon-related
                activities. By leveraging AI models to estimate carbon stock
                capacities and facilitating carbon offset credit trading between
                landowners and companies, this platform seeks to promote the
                growth of carbon sinks and reduce overall carbon emissions.
                Through advanced features like visual land development tools and
                MCDA-based template generation, users can make informed
                decisions, plan carbon activities, and generate insightful
                reports for sustainable land use and investment.
              </p>
            </div>
          </div>
        </div>
        <div className="section" id="description">
          <div className="content-fit">
            <div className="number">02</div>
            <div className="des">
              <div className="title">Highlight Technologies</div>
              <p>Multi-criteria decision making (MCDM)</p>
              <p>Cacbon Stock Estimation</p>
              <p>Tree semantic segmentation</p>
              <p>Tree segmentation / crown delineation</p>
            </div>
          </div>
        </div>
        <div className="section" id="contact">
          <div className="content-fit">
            <div className="number">03</div>
            <div className="des">
              <div className="title centered-column">Members</div>
              <Table>
                <TeamMembers />
              </Table>
              <Button
                className="sign my-3"
                // icon="left-arrow"
                onClick={() => navigate('/home')}
              >
                Start
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
